import { ApiSchemaSuperAdmin } from "../../models/api/apiSchemaSuperAdmin";
import { AppRoutesApi } from "../../config/appRoutes";
import { AxiosAuth } from "../axios";
import { ApiResponseContainer } from "../../models/api/apiResponseContainer";

type ChangePasswordType = {
  CurrentPassword: string;
  NewPassword: string;
};

const getSuperAdminList = async () => {
  const res = await AxiosAuth.get<ApiResponseContainer<ApiSchemaSuperAdmin[]>>(
    AppRoutesApi.SuperAdmin.SuperAdminList
  );
  return res.data;
};

const getSuperAdminDataById = async (accountId: string) => {
  const res = await AxiosAuth.get<ApiResponseContainer<ApiSchemaSuperAdmin>>(
    AppRoutesApi.SuperAdmin.SuperAdminDataById(accountId)
  );
  return res.data;
};

const createSuperAdmin = async (
  email: string,
  userName: string,
  password: string,
  confirmPassword: string,
  firstName: string,
  lastName: string,
  companyName: string,
  address: string,
  state: string,
  countryId: string,
  role: string
) => {
  const res = await AxiosAuth.post<ApiResponseContainer<ApiSchemaSuperAdmin>>(
    AppRoutesApi.SuperAdmin.SuperAdminCreate,
    {
      email,
      userName,
      password,
      confirmPassword,
      firstName,
      lastName,
      companyName,
      address,
      state,
      countryId,
      role,
    }
  );
  return res.data;
};

const deleteSuperAdmin = async (accountId: string) => {
  const res = await AxiosAuth.post(
    AppRoutesApi.SuperAdmin.SuperAdminDelete(accountId)
  );
  return res.data;
};

const updateSuperAdmin = async (
  Id: string,
  password: string,
  confirmPassword: string,
  firstName: string,
  lastName: string,
  companyName: string,
  address: string,
  state: string,
  countryId: string
) => {
  const body = {
    Id: Id,
    Password: password,
    ConfirmPassword: confirmPassword,
    FirstName: firstName,
    LastName: lastName,
    CompanyName: companyName,
    Address: address,
    State: state,
    CountryId: countryId,
  };
  const res = await AxiosAuth.post<ApiResponseContainer<ApiSchemaSuperAdmin>>(
    AppRoutesApi.SuperAdmin.SuperAdminUpdate,
    body
  );
  return res.data;
};

const activeStatus = async (Id: string, IsActive: boolean) => {
  const body = {
    Id: Id,
    IsActive: IsActive,
  };
  const res = await AxiosAuth.post<ApiResponseContainer<ApiSchemaSuperAdmin>>(
    AppRoutesApi.SuperAdmin.SuperAdminToggleStatus(Id),
    body
  );
  return res.data;
};

const changePassword = async (currentPassword: string, newPassword: string) => {
  const res = await AxiosAuth.post<ChangePasswordType>(
    AppRoutesApi.Auth.ChangePassword,
    {
      currentPassword,
      newPassword,
    }
  );
  return res.data;
};

export const ApiSuperAdmin = {
  getSuperAdminList,
  createSuperAdmin,
  deleteSuperAdmin,
  getSuperAdminDataById,
  updateSuperAdmin,
  activeStatus,
  changePassword,
};
